import { render, staticRenderFns } from "./submit-job-work-permit.dialog.vue?vue&type=template&id=1c74a4cf"
import script from "./submit-job-work-permit.dialog.ts?vue&type=script&lang=ts&external"
export * from "./submit-job-work-permit.dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c74a4cf')) {
      api.createRecord('1c74a4cf', component.options)
    } else {
      api.reload('1c74a4cf', component.options)
    }
    module.hot.accept("./submit-job-work-permit.dialog.vue?vue&type=template&id=1c74a4cf", function () {
      api.rerender('1c74a4cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/submit-job-work-permit-dialog/submit-job-work-permit.dialog.vue"
export default component.exports